import { Controller } from "@hotwired/stimulus"

// This controller is used to update the displayed columns and then reloads the page or turbo frame.
export default class extends Controller {
  static get targets() {
    return ["column"]
  }

  static get values() {
    return { path: String, setting: String, turboFrame: String }
  }

  update() {
    const self = this

    let displayedColumns = []
    this.columnTargets.forEach((column) => {
      if (column.checked) {
        displayedColumns.push(column.value)
      }
    })

    fetch(this.pathValue, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "X-CSRF-Token": $("meta[name='csrf-token']").attr("content"),
      },
      body: JSON.stringify({
        user: { [self.settingValue]: displayedColumns },
      }),
      credentials: "same-origin",
    }).then(() => {
      if (self.hasTurboFrameValue) {
        document.querySelector(`turbo-frame#${self.turboFrameValue}`).reload()
      } else {
        location.reload()
      }
    })
  }
}
